<template>
    <div class="col-xl-12" :key="post.ig_postid">
        <div class="card card-custom gutter-b">
            <!--begin::Body-->
            <div class="card-body">
                <!--begin::Header-->
                <div class="d-flex align-items-center">
                    <!--begin::Symbol-->
                    <div class="symbol symbol-75 symbol-light-success mr-5">
                        <span class="symbol-label bg-white">
                            <img
                                :src="post.thumbnail"
                                class="h-100 align-self-end overflow-hidden"
                                alt=""
                            />
                        </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Info-->
                    <div class="d-flex flex-column flex-grow-1">
                        <a
                            class="text-dark-75 text-hover-primary mb-1 font-size-lg font-weight-bolder"
                        >
                            <i :class="getPostIcon(post.nice_type)"></i>
                            {{ post.nice_type }} post
                        </a>
                        <span class="text-muted font-weight-bold">
                            <a
                                class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                                ><span class="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                    ><i class="flaticon-clock-2"></i></span
                                ><span>Posted {{ post.time_ago }}</span></a
                            >
                        </span>
                    </div>
                    <!--end::Info-->
                    <!--begin::Dropdown-->
                    <!-- <div
                                                class="dropdown dropdown-inline ml-2"
                                                data-toggle="tooltip"
                                                title=""
                                                data-placement="left"
                                                data-original-title="Quick actions"
                                            >
                                                <a
                                                    href="#"
                                                    class="btn btn-hover-light-primary btn-sm btn-icon"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    <i class="ki ki-bold-more-hor"></i>
                                                </a>
                                                <div
                                                    class="dropdown-menu p-0 m-0 dropdown-menu-md dropdown-menu-right"
                                                >
                                                    <ul class="navi navi-hover">
                                                        <li
                                                            class="navi-header font-weight-bold py-4"
                                                        >
                                                            <span class="font-size-lg"
                                                                >Choose Label:</span
                                                            >
                                                            <i
                                                                class="flaticon2-information icon-md text-muted"
                                                                data-toggle="tooltip"
                                                                data-placement="right"
                                                                title=""
                                                                data-original-title="Click to learn more..."
                                                            ></i>
                                                        </li>
                                                        <li
                                                            class="navi-separator mb-3 opacity-70"
                                                        ></li>
                                                        <li class="navi-item">
                                                            <a href="#" class="navi-link">
                                                                <span class="navi-text">
                                                                    <span
                                                                        class="label label-xl label-inline label-light-success"
                                                                        >Customer</span
                                                                    >
                                                                </span>
                                                            </a>
                                                        </li>
                                                        <li class="navi-item">
                                                            <a href="#" class="navi-link">
                                                                <span class="navi-text">
                                                                    <span
                                                                        class="label label-xl label-inline label-light-danger"
                                                                        >Partner</span
                                                                    >
                                                                </span>
                                                            </a>
                                                        </li>
                                                        <li class="navi-item">
                                                            <a href="#" class="navi-link">
                                                                <span class="navi-text">
                                                                    <span
                                                                        class="label label-xl label-inline label-light-warning"
                                                                        >Suplier</span
                                                                    >
                                                                </span>
                                                            </a>
                                                        </li>
                                                        <li class="navi-item">
                                                            <a href="#" class="navi-link">
                                                                <span class="navi-text">
                                                                    <span
                                                                        class="label label-xl label-inline label-light-primary"
                                                                        >Member</span
                                                                    >
                                                                </span>
                                                            </a>
                                                        </li>
                                                        <li class="navi-item">
                                                            <a href="#" class="navi-link">
                                                                <span class="navi-text">
                                                                    <span
                                                                        class="label label-xl label-inline label-light-dark"
                                                                        >Staff</span
                                                                    >
                                                                </span>
                                                            </a>
                                                        </li>
                                                        <li
                                                            class="navi-separator mt-3 opacity-70"
                                                        ></li>
                                                        <li class="navi-footer py-4">
                                                            <a
                                                                class="btn btn-clean font-weight-bold btn-sm"
                                                                href="#"
                                                            >
                                                                <i class="ki ki-plus icon-sm"></i
                                                                >Add new</a
                                                            >
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div> -->
                </div>
                <!--end::Header-->
                <!--begin::Body-->
                <div class="pt-5">
                    <!--begin::Text-->
                    <!-- <p
                                                class="
                                                    text-dark-75
                                                    font-size-lg font-weight-normal
                                                    mb-2
                                                "
                                            >
                                                Outlines keep you honest. They stop you from
                                                indulging in poorly thought-out metaphors about
                                                driving and keep you focused on the overall
                                                structure of your post
                                            </p> -->
                    <!--end::Text-->
                    <!--begin::Action-->
                    <div class="d-flex align-items-center">
                        <b-button
                            v-b-tooltip.hover
                            title="Comments"
                            variant="no-variant"
                            class="btn btn-hover-text-primary btn-hover-icon-primary btn-sm btn-text-dark-50 bg-hover-light-primary rounded font-weight-bolder font-size-sm p-2 mr-2"
                        >
                            <span class="svg-icon svg-icon-md svg-icon-dark-25 pr-2">
                                <inline-svg
                                    src="/media/svg/icons/Communication/Group-chat.svg"
                                ></inline-svg> </span
                            >{{ abbreviateNumber(post.comments) }}</b-button
                        >
                        <b-button
                            v-b-tooltip.hover
                            title="Likes"
                            variant="no-variant"
                            class="btn btn-sm btn-text-dark-50 btn-hover-icon-danger btn-hover-text-danger bg-hover-light-danger font-weight-bolder rounded font-size-sm p-2 mr-2"
                        >
                            <span class="svg-icon svg-icon-md svg-icon-dark-25 pr-1">
                                <inline-svg
                                    src="/media/svg/icons/General/Heart.svg"
                                ></inline-svg> </span
                            >{{ abbreviateNumber(post.likes) }}</b-button
                        >
                        <b-button
                            v-b-tooltip.hover
                            title="Engagement"
                            variant="no-variant"
                            class="btn btn-hover-text-success btn-hover-icon-success btn-sm btn-text-dark-50 bg-hover-light-success rounded font-weight-bolder font-size-sm p-2 mr-2"
                        >
                            <span class="svg-icon svg-icon-md svg-icon-dark-25 pr-2">
                                <inline-svg
                                    src="/media/svg/icons/Shopping/Chart-pie.svg"
                                ></inline-svg>
                                <!--end::Svg Icon-->
                            </span>
                            {{ calculateEngagement(post.likes, currentAccount.user.followers) }}
                        </b-button>
                        <template v-if="post.impressions">
                            <b-button
                                v-b-tooltip.hover
                                title="Impressions"
                                variant="no-variant"
                                class="btn-outline-light btn btn-hover-text-success btn-hover-icon-success btn-sm btn-text-dark-50 bg-hover-light-success rounded font-weight-bolder font-size-sm p-2 mr-2"
                            >
                                <span class="pr-2"> <i class="far fa-eye text-dark-25"></i> </span>
                                {{ abbreviateNumber(post.impressions) }}
                            </b-button>
                        </template>
                        <template v-if="post.reach">
                            <!-- <a
                                class="
                                    btn-outline-light
                                    btn
                                    btn-hover-text-success
                                    btn-hover-icon-success
                                    btn-sm
                                    btn-text-dark-50
                                    bg-hover-light-success
                                    rounded
                                    font-weight-bolder font-size-sm
                                    p-2
                                    mr-2
                                "
                            >
                                <span class="svg-icon svg-icon-md svg-icon-dark-25 pr-2">
                                    Reach
                                </span>
                                {{ abbreviateNumber(post.reach) }}
                            </a> -->
                            <b-button
                                v-b-tooltip.hover
                                title="Reach"
                                variant="no-variant"
                                class="btn-outline-light btn btn-hover-text-success btn-hover-icon-success btn-sm btn-text-dark-50 bg-hover-light-success rounded font-weight-bolder font-size-sm p-2 mr-2"
                            >
                                <span class="pr-2 svg-icon svg-icon-md svg-icon-dark-25">
                                    <inline-svg
                                        src="/media/svg/icons/Communication/Group.svg"
                                    ></inline-svg>
                                </span>
                                {{ abbreviateNumber(post.reach) }}
                            </b-button>
                        </template>
                    </div>
                    <!--end::Action-->
                </div>
                <!--end::Body-->
                <!--begin::Separator-->
                <div class="separator separator-solid mt-2 mb-4"></div>
                <!--end::Separator-->

                <!-- NOTE - Display Campaign tables -->
                <!-- NOTE - Check if we actually have campaign data for this post -->

                <div class="d-flex align-items-center flex-wrap">
                    <b-tabs pills content-class="mt-3" class="w-100">
                        <template v-if="post.campaign_data">
                            <b-tab title-item-class="mytab" active>
                                <template slot="title">
                                    <i class="fas fa-medal pr-2"></i>
                                    Hashtags you ranked on
                                </template>
                                <div v-if="post.campaign_data.rank_data.length > 0">
                                    <InfoBox
                                        text="This table indicates the position your post ranked within the 'top posts' section of a hashtag feed."
                                    ></InfoBox>

                                    <!-- Select / Deselect toolbar -->
                                    <div class="card card-custom">
                                        <div class="card-header">
                                            <div class="card-title"></div>
                                            <div class="card-toolbar d-print-none">
                                                <div class="btn-group">
                                                    <b-button
                                                        variant="light-primary"
                                                        size="sm"
                                                        @click="selectAll('ranked')"
                                                        >Select All</b-button
                                                    >
                                                    <b-button
                                                        variant="light-danger"
                                                        size="sm"
                                                        @click="deselectAll('ranked')"
                                                        >Deselect All</b-button
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Table -->
                                    <b-table
                                        striped
                                        hover
                                        selectable
                                        bordered
                                        select-mode="multi"
                                        @row-clicked="(item) => onRowClicked(item)"
                                        :fields="fields"
                                        :items="post.campaign_data.rank_data"
                                        :per-page="15"
                                        :current-page="post.campaign_data.currentPageRanked"
                                        sortBy="minrank"
                                        :sort-compare="customTableSort"
                                        responsive="sm"
                                        ref="selectableTable"
                                    >
                                        <template v-slot:cell(selected)="{ item, field: { key } }">
                                            <template v-if="item[key]">
                                                <span aria-hidden="true"
                                                    ><i
                                                        class="far fa-check-square text-primary font-weight-bolder"
                                                    ></i
                                                ></span>
                                                <span class="sr-only">Selected</span>
                                            </template>
                                            <template v-else>
                                                <span aria-hidden="true"
                                                    ><i class="far fa-square"></i
                                                ></span>
                                                <span class="sr-only">Not selected</span>
                                            </template>
                                            <!-- <b-checkbox v-model="item[key]"></b-checkbox> -->
                                        </template>

                                        <!-- Hashtag badge slot -->
                                        <template
                                            v-slot:cell(hashtagsBadged)="{ item, field: { key } }"
                                        >
                                            {{ item.hashtag }}
                                            <span
                                                class="badge badge-warning"
                                                v-if="item.status == 'flagged'"
                                                >Flagged</span
                                            >
                                            <span
                                                class="badge badge-danger"
                                                v-if="item.status == 'banned'"
                                                >Banned</span
                                            >
                                        </template>
                                    </b-table>
                                    <b-pagination
                                        v-model="post.campaign_data.currentPageRanked"
                                        :total-rows="post.campaign_data.rank_data.length"
                                        :per-page="15"
                                        align="center"
                                        aria-controls="my-table"
                                    ></b-pagination>
                                </div>
                                <div v-else>
                                    <InfoBox
                                        text="This post hasn't yet ranked on any hashtags."
                                    ></InfoBox>
                                </div>
                            </b-tab>

                            <b-tab title-item-class="mytab">
                                <template slot="title">
                                    <i class="fas fa-times-circle pr-2"></i>
                                    Unranked hashtags
                                </template>

                                <div v-if="post.campaign_data.unranked.length > 0">
                                    <InfoBox
                                        text="This table indicates the instances where your post didn't rank in the 'top posts' section of a hashtag feed."
                                    ></InfoBox>

                                    <!-- Select / Deselect toolbar -->
                                    <div class="card card-custom">
                                        <div class="card-header">
                                            <div class="card-title"></div>
                                            <div class="card-toolbar d-print-none">
                                                <div class="btn-group">
                                                    <b-button
                                                        variant="light-primary"
                                                        size="sm"
                                                        @click="selectAll('unranked')"
                                                        >Select All</b-button
                                                    >
                                                    <b-button
                                                        variant="light-danger"
                                                        size="sm"
                                                        @click="deselectAll('unranked')"
                                                        >Deselect All</b-button
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Table -->
                                    <b-table
                                        striped
                                        hover
                                        selectable
                                        bordered
                                        select-mode="multi"
                                        @row-clicked="(item) => onRowClicked(item)"
                                        :fields="fields"
                                        :items="post.campaign_data.unranked"
                                        :per-page="15"
                                        :current-page="post.campaign_data.currentPageUnranked"
                                        sortBy="minrank"
                                        :sort-compare="customTableSort"
                                        responsive="sm"
                                        ref="selectableTable"
                                    >
                                        <template v-slot:cell(selected)="{ item, field: { key } }">
                                            <template v-if="item[key]">
                                                <span aria-hidden="true"
                                                    ><i
                                                        class="far fa-check-square text-primary font-weight-bolder"
                                                    ></i
                                                ></span>
                                                <span class="sr-only">Selected</span>
                                            </template>
                                            <template v-else>
                                                <span aria-hidden="true"
                                                    ><i class="far fa-square"></i
                                                ></span>
                                                <span class="sr-only">Not selected</span>
                                            </template>
                                            <!-- <b-checkbox v-model="item[key]"></b-checkbox> -->
                                        </template>

                                        <!-- Hashtag badge slot -->
                                        <template
                                            v-slot:cell(hashtagsBadged)="{ item, field: { key } }"
                                        >
                                            {{ item.hashtag }}
                                            <span
                                                class="badge badge-warning"
                                                v-if="item.status == 'flagged'"
                                                >Flagged</span
                                            >
                                            <span
                                                class="badge badge-danger"
                                                v-if="item.status == 'banned'"
                                                >Banned</span
                                            >
                                        </template>
                                    </b-table>
                                    <b-pagination
                                        v-model="post.campaign_data.currentPageUnranked"
                                        :total-rows="post.campaign_data.unranked.length"
                                        :per-page="15"
                                        aria-controls="my-table"
                                        align="center"
                                    ></b-pagination>
                                </div>
                                <div v-else>
                                    <InfoBox
                                        text="There are no hashtags on which this post hasn't ranked"
                                    ></InfoBox>
                                </div>
                            </b-tab>
                        </template>

                        <!-- NOTE - Caption -->
                        <b-tab title-item-class="mytab">
                            <template slot="title">
                                <i class="fas fa-align-left pr-2"></i>
                                Caption
                            </template>
                            <div class="caption">
                                {{ post.post_caption }}
                            </div>
                        </b-tab>
                        <!-- NOTE - End Caption -->

                        <!-- NOTE - Display all hashtags used -->
                        <template v-if="post.hashtag_data">
                            <b-tab title-item-class="mytab">
                                <template slot="title">
                                    <i class="fas fa-hashtag pr-2"></i>
                                    Hashtags used
                                </template>
                                <template v-if="post.hashtag_data.data.length > 0">
                                    <InfoBox
                                        text="This table contains all the hashtags identified on your post."
                                    ></InfoBox>

                                    <!-- Select / Deselect toolbar -->
                                    <div class="card card-custom">
                                        <div class="card-header">
                                            <div class="card-title"></div>
                                            <div class="card-toolbar d-print-none">
                                                <div class="btn-group">
                                                    <b-button
                                                        variant="light-primary"
                                                        size="sm"
                                                        @click="selectAll('non_campaign')"
                                                        >Select All</b-button
                                                    >
                                                    <b-button
                                                        variant="light-danger"
                                                        size="sm"
                                                        @click="deselectAll('non_campaign')"
                                                        >Deselect All</b-button
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Table -->
                                    <b-table
                                        striped
                                        hover
                                        selectable
                                        bordered
                                        select-mode="multi"
                                        @row-clicked="(item) => onRowClicked(item)"
                                        :fields="fields_non_campaign"
                                        :items="post.hashtag_data.data"
                                        :per-page="15"
                                        :current-page="post.hashtag_data.page"
                                        sortBy="minrank"
                                        :sort-compare="customTableSort"
                                        responsive="sm"
                                        ref="selectableTable"
                                    >
                                        <template v-slot:cell(selected)="{ item, field: { key } }">
                                            <template v-if="item[key]">
                                                <span aria-hidden="true"
                                                    ><i
                                                        class="far fa-check-square text-primary font-weight-bolder"
                                                    ></i
                                                ></span>
                                                <span class="sr-only">Selected</span>
                                            </template>
                                            <template v-else>
                                                <span aria-hidden="true"
                                                    ><i class="far fa-square"></i
                                                ></span>
                                                <span class="sr-only">Not selected</span>
                                            </template>
                                            <!-- <b-checkbox v-model="item[key]"></b-checkbox> -->
                                        </template>

                                        <!-- Hashtag badge slot -->
                                        <template
                                            v-slot:cell(hashtagsBadged)="{ item, field: { key } }"
                                        >
                                            {{ item.hashtag }}
                                            <span
                                                class="badge badge-warning"
                                                v-if="item.status == 'flagged'"
                                                >Flagged</span
                                            >
                                            <span
                                                class="badge badge-danger"
                                                v-if="item.status == 'banned'"
                                                >Banned</span
                                            >
                                        </template>
                                    </b-table>
                                    <b-pagination
                                        v-model="post.hashtag_data.page"
                                        :total-rows="post.hashtag_data.data.length"
                                        :per-page="15"
                                        aria-controls="my-table"
                                        align="center"
                                    ></b-pagination>
                                </template>
                                <template v-else>
                                    <InfoBox
                                        text="There are no hashtags identified on this post."
                                    ></InfoBox>
                                </template>
                            </b-tab>
                        </template>
                        <!-- NOTE - End Display all hashtags used -->
                    </b-tabs>
                </div>
                <!--end::Bottom-->
            </div>
            <!--end::Body-->
        </div>
    </div>
</template>
<style scoped>
.caption {
    padding: 1.5rem;
    border-left: 4px solid #e2e5ec;
    background-color: #f7f8fa;
    white-space: pre-line;
}
.tabs /deep/ .tab-pane:focus {
    outline: none;
}
.tabs /deep/ .mytab > .active {
    background-color: white;
    color: #1dc9b7;
    font-weight: 600;
}
.tabs /deep/ .mytab > .active i {
    background-color: white;
    color: #1dc9b7;
    font-weight: 600;
}
.tabs /deep/ .mytab > .active a {
    border-bottom: 3px;
}
.tabs /deep/ .nav-pills {
    border-style: solid;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-color: rgba(29, 201, 183, 0.1);
}
</style>
<script>
// Mixins
import stringManagement from "@/mixins/stringManagement";
import hashtagTableManagement from "@/mixins/hashtagTableManagement";

// Components
import InfoBox from "@/view/content/Custom/InfoBox.vue";
export default {
    name: "AccountDashboardPost",
    props: ["currentAccount", "post"],
    mixins: [stringManagement, hashtagTableManagement],
    components: {
        InfoBox,
    },
    data() {
        return {
            // Fields for Ranked / Unranked
            fields: [
                {
                    key: "selected",
                    label: "",
                },
                {
                    key: "hashtag",
                    sortable: true,
                    tdClass: "d-none",
                    thClass: "d-none",
                },
                {
                    key: "hashtagsBadged",
                    sortable: true,
                    label: "Hashtags",
                },
                {
                    key: "minrank",
                    sortable: true,
                    label: "Rank",
                    formatter: (value, key, item) => {
                        return this.makeOrdinal(value);
                    },
                },
                {
                    key: "count",
                    sortable: true,
                    label: "Post count",
                    formatter: (value) => {
                        if (value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                    },
                },
                {
                    key: "DAPC_weekly",
                    sortable: true,
                    label: "Daily Posts",
                    formatter: (value) => {
                        if (value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(Math.round(value));
                    },
                },
                {
                    key: "score",
                    sortable: true,
                    label: "Score",
                },
                {
                    key: "avgMaxLikes",
                    sortable: true,
                    label: "Max Likes in Top 9",
                    formatter: (value) => {
                        if (value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                    },
                },
                {
                    key: "avgMinLikes",
                    sortable: true,
                    label: "Min Likes in Top 9",
                    formatter: (value) => {
                        if (value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                    },
                },
                {
                    key: "avgAvgLikes",
                    sortable: true,
                    label: "Average Likes in Top 9",
                    formatter: (value) => {
                        if (value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                    },
                },
            ],
            fields_non_campaign: [
                {
                    key: "selected",
                    label: "",
                },
                {
                    key: "hashtag",
                    sortable: true,
                    tdClass: "d-none",
                    thClass: "d-none",
                },
                {
                    key: "hashtagsBadged",
                    sortable: true,
                    label: "Hashtags",
                },
                {
                    key: "count",
                    sortable: true,
                    label: "Post count",
                    formatter: (value) => {
                        if (value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                    },
                },
                {
                    key: "DAPC_weekly",
                    sortable: true,
                    label: "Daily Posts",
                    formatter: (value) => {
                        if (value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(Math.round(value));
                    },
                },
                {
                    key: "score",
                    sortable: true,
                    label: "Score",
                },
                {
                    key: "avgMaxLikes",
                    sortable: true,
                    label: "Max Likes in Top 9",
                    formatter: (value) => {
                        if (value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                    },
                },
                {
                    key: "avgMinLikes",
                    sortable: true,
                    label: "Min Likes in Top 9",
                    formatter: (value) => {
                        if (value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                    },
                },
                {
                    key: "avgAvgLikes",
                    sortable: true,
                    label: "Average Likes in Top 9",
                    formatter: (value) => {
                        if (value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                    },
                },
            ],
        };
    },
    methods: {
        getPostIcon(type) {
            if (type == "Photo") {
                return "fas fa-camera";
            }
            if (type == "Video") {
                return "fas fa-video";
            }
            if (type == "Carousel") {
                return "fas fa-photo-video";
            }
            if (type == "Reels") {
                return "fas fa-video";
            }
            return "fas fa-question-circle";
        },

        emitClickedOnRow() {
            this.$emit("clickedOnRow");
        },

        onRowClicked(item) {
            // Hack
            if (item.selected) {
                this.$set(item, "selected", false);
            } else {
                this.$set(item, "selected", true);
            }

            // Emit to parent that we need to get all selected hashtags
            // this.getAllSelectedItems();
            this.emitClickedOnRow();
        },

        loopThroughTableAndSet(variant, value) {
            if (variant == "ranked") {
                if (this.post.campaign_data.rank_data.length > 0) {
                    this.post.campaign_data.rank_data.forEach((part, index, theArray) => {
                        this.$set(this.post.campaign_data.rank_data[index], "selected", value);
                    });
                }
            }
            if (variant == "unranked") {
                if (this.post.campaign_data.unranked.length > 0) {
                    this.post.campaign_data.unranked.forEach((part, index, theArray) => {
                        this.$set(this.post.campaign_data.unranked[index], "selected", value);
                    });
                }
            }
            if (variant == "non_campaign") {
                if (this.post.hashtag_data.data.length > 0) {
                    this.post.hashtag_data.data.forEach((part, index, theArray) => {
                        this.$set(this.post.hashtag_data.data[index], "selected", value);
                    });
                }
            }
        },

        selectAll(variant) {
            this.loopThroughTableAndSet(variant, true);
            this.emitClickedOnRow();
        },

        deselectAll(variant) {
            this.loopThroughTableAndSet(variant, false);
            this.emitClickedOnRow();
        },
    },
};
</script>
